/* eslint-disable react/prefer-stateless-function */
import { without } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import Field from 'components/Field'
import InputCheckbox from 'components/InputCheckbox'

export default class FieldWithInputCheckboxes extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      checked: [],
    }
  }

  //componentWillReceiveProps(nextProps) {
  //  this.setState({ checked: nextProps.checked || '' })
  //}

  handleChange = (e) => {
    const { value } = e.target
    const { onChange } = this.props
    const { checked } = this.state

    const items = !checked.includes(value) ? [...checked, value] : without(checked, value)

    this.setState({ checked: items })

    if (onChange) onChange(items)
  }

  render() {
    //const { title, ...props } = this.props
    //const { inputs, title, ...props } = this.props
    //const { checked, inputs, name, title, onChange } = this.props
    const { inputs, title } = this.props
    const { checked } = this.state

    return (
      <Field className="FieldWithInputCheckboxes uk-form-stacked">
        {title &&
          <h3 className="uk-form-label">
            {title}
          </h3>
        }
        {inputs.map((input) => {
          const value = input.value || input.option

          return (
            <InputCheckbox
              label={input.option}
              checked={checked.includes(value)}
              value={value}
              onChange={this.handleChange}
              key={input.option}
            />
          )
        })}
      </Field>
    )
  }
}

FieldWithInputCheckboxes.propTypes = {
  checked: PropTypes.array,
  inputs: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  title: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/FieldWithInputCheckboxes/FieldWithInputCheckboxes.js